import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    Course,
    PurchasedGfitCourse,
    GiftToSend,
    ReceivedGift,
} from "JS/Models";
import moment from "moment";

export interface CourseState {
    courses?: Course[];
    receivedCourses?: ReceivedGift[];
    purchasableCoursesForMembers?: Course[];
    purchasedGiftCourses?: PurchasedGfitCourse[];
    coursesToSend?: GiftToSend[];
    giftsGiven?: any;
    activeCourse?: ActiveCourse;
    isUpdateRequired?: boolean;
    cacheTime?: number;
}

export enum ActiveCourseType {
    RECEIVED = "RECEIVED",
    UNRECIEVED = "UNRECEIVED",
}

interface BaseActiveCourse {
    type: ActiveCourseType;
}

interface ActiveUnReceivedCourse extends BaseActiveCourse {
    type: ActiveCourseType.UNRECIEVED;
    course: Course;
}
interface ActiveReceivedCourse extends BaseActiveCourse {
    type: ActiveCourseType.RECEIVED;
    course: ReceivedGift;
}

export type ActiveCourse = ActiveUnReceivedCourse | ActiveReceivedCourse;

const initialState: CourseState = {
    courses: [],
    receivedCourses: [],
    purchasableCoursesForMembers: [],
    activeCourse: null,
    purchasedGiftCourses: [],
    giftsGiven: [],
    isUpdateRequired: undefined,
    coursesToSend: [],
    cacheTime: 0,
};

export const courseStateSlice = createSlice({
    name: "courseState",
    initialState,
    reducers: {
        setGlobalCourses: (state, data: PayloadAction<CourseState>) => {
            state.courses = data.payload.courses;
            state.isUpdateRequired = undefined;
            state.cacheTime = moment().unix() + 5000; // to adjust for time differences between server side and client side
            return state;
        },
        setGlobalReceivedCourses: (state, data: PayloadAction<CourseState>) => {
            state.receivedCourses = data.payload.receivedCourses;
            return state;
        },
        setGlobalPurchasableCourses: (
            state,
            data: PayloadAction<CourseState>,
        ) => {
            if (data.payload.purchasableCoursesForMembers)
                state.purchasableCoursesForMembers =
                    data.payload.purchasableCoursesForMembers;

            return state;
        },
        setGlobalPurchasedCourses: (
            state,
            data: PayloadAction<CourseState>,
        ) => {
            state.coursesToSend = data.payload.coursesToSend;
            state.purchasedGiftCourses = [];
            return state;
        },
        setActiveCourse: (state, data: PayloadAction<CourseState>) => {
            state.activeCourse = data.payload.activeCourse;

            return state;
        },
        setGlobalCourseGiftsGiven: (
            state,
            data: PayloadAction<CourseState>,
        ) => {
            if (data.payload.giftsGiven)
                state.giftsGiven = data.payload.giftsGiven;
        },
        resetCourseState: () => initialState,
    },
});
export const {
    setGlobalCourses,
    setGlobalReceivedCourses,
    setGlobalPurchasableCourses,
    setActiveCourse,
    setGlobalPurchasedCourses,
    setGlobalCourseGiftsGiven,
    resetCourseState,
} = courseStateSlice.actions;
